module.exports = __webpack_public_path__ + "media/assets/icons/ic-earth-b819685f194b0606936decdb33366f00.svg";